// extracted by mini-css-extract-plugin
export default {"container":"container_oQPlf","header":"header_AtNPQ","lines":"lines__sOjB","line":"line_kBizi","isSmall":"isSmall_eZRHj","buttons":"buttons_RgRaq","texts":"texts_pQov0"};